import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing a view for a summarized cash flow record table.
 * @extends JetView
 */
export default class recordTableFlujoCajaResumidoView extends JetView {
    /**
     * Configures the datatable view.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        return {
            view: 'datatable', // Specifies the view type
            select: true, // Enables row selection
            columns: [
                // Defines the columns of the datatable
                {
                    id: 'package', // Unique identifier for the column
                    header: _('dav'), // Header text, localized
                    fillspace: 2, // Column width relative to others
                    minWidth: 100, // Minimum width of the column
                    sort: 'text', // Sorting type for the column
                    format: dateFormat, // Formatting function for the column data
                },
                {
                    id: 'maintainer', // Unique identifier for the column
                    header: _('ID Usuario'), // Header text, localized
                    width: 100, // Fixed width of the column
                    sort: 'int', // Sorting type for the column
                },
                {
                    id: 'architecture', // Unique identifier for the column
                    header: _('Transacción ID'), // Header text, localized
                    width: 100, // Fixed width of the column
                    sort: 'int', // Sorting type for the column
                },
            ],
            loadahead: devConfig.getDefaultDataFetch(), // Data fetching configuration
            pager: 'pagerA', // Pager configuration
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        this.on(this.app, 'user:id', (Id) => {
            // Event listener for user ID changes
            grid.load(
                // Loads data into the grid
                devConfig.geturlApi() + // Base API URL
                    'es/Financial/GetFlujoCajaResumido' + // API endpoint
                    '?id=' + // Query parameter for user ID
                    Id, // User ID value
            );
        });
    }
}

// FILE DOCUMENTED
